import LandingPage from './containers/LandingPage/LandingPage';
import ServicePage from './containers/ServicePage/ServicePage';
import ServicesPage from './containers/ServicesPage/ServicesPage';
import PrivacyPolicyPage from './containers/PrivacyPolicyPage/PrivacyPolicyPage';
import TermsOfServicePage from './containers/TermsOfServicePage/TermsOfServicePage';
import NotFoundPage from './containers/NotFoundPage/NotFoundPage';
import routePaths from './routePaths';

/**
 * Binds each route in the table to its page component.
 *
 * Statically imported, not `React.lazy`. A lazy component suspends on its
 * first render, so the client's first pass produced the Suspense fallback —
 * an empty full-height div — while the prerendered HTML held the real page.
 * Nothing can reconcile those, and hydration failed on every route because
 * of it. The webpack config here emits a single bundle, so these were never
 * separate chunks and the split was notional anyway.
 *
 * Only App/Routes should import this. Anything that just needs a path should
 * import routePaths instead — see the note there about the import cycle.
 */
const components = {
  LandingPage,
  ServicesPage,
  PrivacyPolicyPage,
  TermsOfServicePage,
  NotFoundPage,
};

/**
 * The eight service routes share one component and are told apart by the
 * `serviceId` routePaths put on them, handed over as `extraProps` — the prop
 * bag Routes.js already spreads onto the matched page. A path parameter
 * (`/services/:slug`) would have meant re-adding the parameter compilation
 * that util/routes.js and NamedLink were deliberately stripped of.
 */
const routeConfiguration = routePaths.map(route => ({
  ...route,
  component: route.serviceId ? ServicePage : components[route.name],
  ...(route.serviceId ? { extraProps: { serviceId: route.serviceId } } : {}),
}));

export default routeConfiguration;
